import { isVoximplantNoiseError } from "shared/lib/voximplant/is-voximplant-noise-error"

const REJECTION_GUARD_KEY = "__t2VoximplantRejectionGuard"

/**
 * Глушит известный unhandledRejection из kit.voximplant (reconnect).
 * Нужен preventDefault, чтобы ошибка не уходила в Next/Hawk как unhandled.
 */
export const installVoximplantRejectionGuard = () => {
  if (typeof window === "undefined") return
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- one-shot flag on window
  if ((window as any)[REJECTION_GUARD_KEY])
    return // eslint-disable-next-line @typescript-eslint/no-explicit-any -- one-shot flag on window
  ;(window as any)[REJECTION_GUARD_KEY] = true

  window.addEventListener("unhandledrejection", (event) => {
    if (!isVoximplantNoiseError(event.reason)) return
    event.preventDefault()
    // INFO [a.savrov (31-07-2026 - 18:51)]: глушим до Hawk/Next, если guard повешен раньше их listeners
    event.stopImmediatePropagation()
  })
}

/** Безопасный init виджета: sync try/catch + catch промиса, если init вернул Promise. */
export const safeInitVoxKitWidget = (settings: NonNullable<Window["VoxKitWidgetSettings"]>) => {
  installVoximplantRejectionGuard()

  if (typeof window.VoxKitWidget?.init !== "function") return

  try {
    const result = window.VoxKitWidget.init(settings) as unknown

    if (result != null && typeof (result as PromiseLike<unknown>).then === "function") {
      Promise.resolve(result).catch((error: unknown) => {
        if (!isVoximplantNoiseError(error)) {
          console.warn("[voximplant] init rejected:", error)
        }
      })
    }
  } catch (error) {
    if (!isVoximplantNoiseError(error)) {
      console.warn("[voximplant] init failed:", error)
    }
  }
}
